import { SUPPORTED_LANGUAGES } from "@/config/languages";
import { fr } from "./languages/fr";
import { en } from "./languages/en";
import { es } from "./languages/es";
import { zh } from "./languages/zh";
import { pt } from "./languages/pt";
import { de } from "./languages/de";
import { ar } from "./languages/ar";
import { ru } from "./languages/ru";
import { it } from "./languages/it";
import { nl } from "./languages/nl";

export const translations = {
  fr,
  en,
  es,
  zh,
  pt,
  de,
  ar,
  ru,
  it,
  nl,
} as const;

export const languages = [...SUPPORTED_LANGUAGES];